<template>
  <el-dialog
    :visible.sync="visible"
    title="库存调配"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >
    <el-form
      :inline="true"
      :model="dataForm"
      :rules="dataRule"
      @keyup.enter.native="getDataList()"
      ref="dataForm"
    >
      <el-form-item label="调出仓库：" prop="checkOutStorageId">
        <storages
          v-model="dataForm.checkOutStorageId"
          :disabled="true"
        ></storages>
      </el-form-item>
      <el-form-item label="接收仓库：" prop="checkInStorageId">
        <storages v-model="dataForm.checkInStorageId"></storages>
      </el-form-item>
      <el-form-item label="新合同号：" prop="agreementCode">
        <el-input v-model="dataForm.agreementCode"></el-input>
      </el-form-item>
      <el-form-item label="调配时间：" prop="operateTime">
        <el-date-picker
          v-model="dataForm.operateTime"
          type="date"
          value-format="yyyy-MM-dd"
          style="width: 100%"
          placeholder="`选择出调配时间`"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="备注：" prop="remark">
        <el-input v-model="dataForm.remark"></el-input>
      </el-form-item>
      <el-table :data="dataForm.detailList" border style="width: 100%">
        <el-table-column
          label="行号"
          type="index"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          label="品番号"
          prop="code"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          label="品名"
          prop="name"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          label="颜色"
          prop="color"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          label="规格"
          prop="size"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          label="幅宽"
          prop="attr1"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          label="克重"
          prop="attr2"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column label="调出数量" header-align="center" align="center">
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.count'"
              :rules="detailRule.count"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.count"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="doSubmit()">确认调仓</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { moneyValidator } from "@/utils/validate";
import { isNumber } from "@/utils/validate";
export default {
  data() {
    return {
      dataForm: {
        agreementCode: "",
        checkOutStorageId: "",
        checkInStorageId: "",
        shippingCost: "",
        currency: "",
        remark: "",
        detailList: [],
      },
      visible: false,
    };
  },
  computed: {
    dataRule() {
      return {
        shippingCost: [{ validator: moneyValidator, trigger: "change" }],
        checkOutStorageId: [
          { required: true, message: "请选择调出仓库", trigger: "change" },
        ],
        checkInStorageId: [
          { required: true, message: "请选择接收仓库", trigger: "change" },
        ],
      };
    },
    detailRule() {
      return {
        count: [
          { required: true, message: "请填写数量", trigger: "change" },
          {
            validator: function(rule, value, callback) {
              if (!isNumber(value)) {
                callback(new Error("请输入正确的数量"));
              }
              callback();
            },
            trigger: "change",
          },
        ],
      };
    },
  },
  methods: {
    cancel() {
      this.visible = false;
    },
    init() {
      this.visible = true;
    },
    async doSubmit() {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$confirm("是否进行库存调配操作?", "操作提示").then(() => {
          this.saveData();
        });
      });
    },
    async saveData() {
      let postForm = {
        agreementCode: this.dataForm.agreementCode,
        checkOutStorageId: this.dataForm.checkOutStorageId,
        checkInStorageId: this.dataForm.checkInStorageId,
        shippingCost: this.dataForm.shippingCost,
        currency: this.dataForm.shippingCost,
        remark: this.dataForm.remark,
        operateTime:this.dataForm.operateTime,
        detailList: this.dataForm.detailList.map((item) => {
          return {
            productId: item.productId,
            agreementId: item.agreementId,
            count: item.count,
          };
        }),
      };

      const { data: res } = await this.$http.post(
        `/trade/factorystore/transfer`,
        postForm
      );
      if (res.code !== 0) {
        return this.$message.error(res.msg);
      }
      this.$message.success("操作成功");
      this.$emit("change");
      this.visible = false;
    },
  },
};
</script>
